// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1CardFinderDefaultResponseData.discriminator = undefined;
PharmacyV1CardFinderDefaultResponseData.additionalProperties = false;
PharmacyV1CardFinderDefaultResponseData.attributeTypeMap = [
    {
        "name": "plans",
        "baseName": "plans",
        "type": ""
    },
    {
        "name": "prescriberNpi",
        "baseName": "prescriberNpi",
        "type": "string"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
];
//# sourceMappingURL=pharmacyV1CardFinderDefaultResponseData.js.map